/* @fflow */
/* eslint-disable no-shadow, no-unused-vars */

import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';

import SearchIcon from 'components/icons/SearchIcon';
import { Spinner } from 'components/UIKit/Spinner';
import style from './style';
import { dropdown } from 'components/UIKit/decorators';
import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import { QuickSearchLink } from 'components/Links';
import {
  CaseIcon,
  BiospecimenIcon,
  ReadGroupIcon,
  AnnotationIcon,
  ClinicalIcon,
} from 'components/icons';
import KeyCode from 'constants/KeyCodes';
import { stringify } from 'qs';
import { useNavigate } from 'react-router';

const QuickSearch = (props) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const inputRef = useRef();
  const navigate = useNavigate();
  let {
    projectID, items, mouseUpHandler, mouseDownHandler, handleSubmit, setActive,
    handleClear, active, categoryMapping, isFetching,
  } = props;

  useEffect(() => {
    if (active) {
      setSelectedIndex(0);
    }
  }, [active])

  const handleKeyDown = (event) => {
     let nextSelectedIndex = selectedIndex;

    if (event.keyCode === KeyCode.Down) {
      if (selectedIndex === items.length - 1) {
        nextSelectedIndex = 0;
      } else {
        nextSelectedIndex = selectedIndex + 1;
      }
    } else if (event.keyCode === KeyCode.Up) {
      if (selectedIndex === 0) {
        nextSelectedIndex = items.length - 1;
      } else {
        nextSelectedIndex = selectedIndex - 1;
      }
    } else if (event.keyCode === KeyCode.Enter) {
      let { items, handleClear, setActive } = props;
      let item = items[selectedIndex];
      if (item) {
        let to = `${item.type}`;
        let query = { id: item.id, did: item.id };
        navigate({
          pathname: `browse/${to}`,
          search: `?=${stringify(query)}`,
        }); 
        inputRef.current.value = '';
      }
      handleClear();
      setActive(false);
      return;
    }
    setSelectedIndex(nextSelectedIndex);
  };

  const doSearch: Function = (event) => {
    if (inputRef.current.value) {
      handleClear();
      handleSubmit(event, inputRef.current.value);
      setActive(true);
    } else {
      handleClear();
      setActive(false);
    }
  };

  let iconStyle = {fontSize: '2rem'};
  let icons = {
    'administrative': <CaseIcon style={iconStyle} />,
    'biospecimen': <BiospecimenIcon style={iconStyle} />,
    'clinical': <ClinicalIcon style={iconStyle} />,
    'data_file': <ReadGroupIcon style={iconStyle} />,
    'data_bundle': <ReadGroupIcon style={iconStyle} />,
    'notation': <AnnotationIcon style={iconStyle} />,
    'default': <CaseIcon style={iconStyle} />,
  };

  let highlight = (foundText) => {
    let query = inputRef.current.value.toLowerCase();
    let foundTextLowered = foundText.toLowerCase();
    let index = foundTextLowered.indexOf(query);
    let seg1 = foundTextLowered.substring(0, index);
    let seg2 = foundTextLowered.substring(index + query.length);
    if (index !== -1) {
      return (
        <span style={{fontSize: '0.9rem'}}>
          { seg1 }
          <strong>
            { query }
          </strong>
          { seg2 }
        </span>
      );
    }
    return (
      <span> {foundText} </span>
    );
  };

  return (
    <div style={{...style.container, visibility: projectID ? 'visible' : 'hidden'}}>
      <SearchIcon style={ style.icon } />
      {projectID &&
        <span style={ style.label }>{projectID}</span>
      }
      <form
        action="#"
        style={{ width: '100%' }}
        onSubmit={(event) => {
          event.preventDefault();
          doSearch();
        }}
      >
        <div data-testid="textbox-search" className="mdl-textfield mdl-js-textfield" style={ style.inputWrapper }>
          <input
            className="mmdl-textfield__input"
            style={ style.input }
            type="text"
            id="search"
            title="Search"
            aria-label="search"
            autoComplete="off"
            onChange={_.debounce(doSearch, 500)}
            ref={inputRef}
            placeholder="Search"
            onKeyDown={handleKeyDown}
          />
          { active &&
            <Column
              className="mdl-shadow--2dp"
              onMouseDown={mouseDownHandler}
              onMouseUp={mouseUpHandler}
              style={{
                position: `absolute`,
                background: `white`,
                padding: `0.5em 0`,
                fontSize: `0.8rem`,
                zIndex: 1000,
                marginTop: 0,
                width: '100%'
              }}
            >
              {(items || []).map((item, i) =>
                <Row
                  key={item.id}
                  className={`${ i === selectedIndex && 'selected'}`}
                  onMouseOver={() => setSelectedIndex(i)}
                  onMouseOut={() => setSelectedIndex(0)}
                  style={{
                    paddingLeft: `0.5rem`,
                    textTransform: `uppercase`,
                    borderBottom: i < items.length - 1 ? '1px solid #e5e5e5' : '0px'
                  }}
                >
                  <QuickSearchLink
                    item={item}
                    style={{
                      display: 'flex',
                      height: '100%',
                      width: '100%',
                      textDecoration: 'none'
                    }}
                    className={`quick-search-link ${ i === selectedIndex && 'selected'}`}
                    onClick={() => {
                      inputRef.current.value = '';
                      setActive(false);
                    }}
                    on
                  >
                    <Row style={{marginRight: '0.5rem', alignItems: 'center'}}>
                      { icons[(categoryMapping[item.type] || 'default')] }
                    </Row>
                    <Column style={{overflow: 'auto'}}>
                      {highlight(item.submitter_id)}
                      <span style={{fontStyle: 'italic'}}>
                        {highlight(item.id)}<br />
                        {`${item.type}, ${item.project_id}`}
                      </span>
                    </Column>
                  </QuickSearchLink>
                </Row>
              )}
              {isFetching &&
                <Row style={{ paddingLeft: '0.5rem', justifyContent: 'center', alignItems: 'center' }}>
                  <Spinner />
                </Row>
              }
              {!(items || []).length && !isFetching && <Row style={{ paddingLeft: '0.5rem' }}>No Results</Row>}
            </Column>
          }
        </div>
      </form>
    </div>
  );
}

export default dropdown(QuickSearch);
